import api from './api';

const BASE_URL = '/cantieri';

export const getCantieri = (stato) =>
  api.get(`${BASE_URL}${stato ? `?stato=${stato}` : ''}`);

export const createCantiere = (nome, stato) => {
  const payload = { nome };
  if (stato !== undefined) payload.stato = stato;
  return api.post(BASE_URL, payload);
};

export const updateStatoCantiere = (id, stato) =>
  api.patch(`${BASE_URL}/${id}`, { stato });

export const deleteCantiere = (id) => api.delete(`${BASE_URL}/${id}`);

export const updateCapitaleCantiere = (id, capitale) =>
  api.patch(`${BASE_URL}/${id}/capitale`, { capitale });
